// constants/suiroFields.js

// 各行のリセットフィールド
export const DATA_ROW_RESET_FIELDS = [
  'is_not_report',
  'occured_at',
  'is_selected_drainage_powerplant',
  'is_notified_irrigation_user1',
  'intake_stop_notifier_person',
  'intake_stop_at',
  'intake_stop_contact_person',
  'intake_stop_completed_at',
  'drainage_notice_sent_at',
  'drainage_notice_sent_person',
  'drainage_notice_sent_user',
  'drainage_completed_at',
  'is_selected_inspection_locations',
  'canalinspector1',
  'canalinspector2',
  'is_canalinspector',
  'request_emergency_inspection_at',
  'request_emergency_inspection_person',
  'request_emergency_inspection_user',
  'inspection_completed_at',
  'is_emergency_inspection',
  'is_manager_report',
  'is_drainage',
  'drainage_request_at',
  'drainage_request_person',
  'drainage_request_user',
  'drainage_at',
  'is_inspection_completed_update_form1',
  'perform_internal_inspection_user1',
  'perform_internal_inspection_user2',
  'is_perform_internal_inspection_user',
  'internal_inspection_completed_at',
  'is_internal_inspection_update_form1',
  'is_decide_restart_locations',
  'is_notified_irrigation_user2',
  'request_waterway_refill_at',
  'request_waterway_refill_person',
  'request_waterway_refill_user',
  'refill_completed_at',
  'is_report_to_g_manager',
  'restart_power_generation_at',
  'is_notified_irrigation_user3',
  'is_completed'
];

// 全発電所共通のリセット対象フィールド
export const COMMON_RESET_FIELDS = [
  // 全発電所共通行フィールド
  'initial_response_at',
  'initial_response_person',
  'is_notified_to_electric_group',
  'notified_irrigation_users_at1',
  'notified_irrigation_users_person1',
  'notified_irrigation_users_at2',
  'notified_irrigation_users_person2',
  'shared_with_hydropower_center_at2',
  'shared_with_hydropower_center_person2',
  'notified_irrigation_users_at3',
  'notified_irrigation_users_person3',
  'is_powerplant_operation_checked',
  'is_intake_stop_completed_share_with_nishiko',
  'is_drainage_after_safety_check',
  'is_drainage_completed_share_with_nishiko',
  'intake_stop_completed_shared_with_hydropower_center_at',
  'intake_stop_completed_shared_with_hydropower_center_person',
];

// 全発電所共通 + 各行のリセットフィールドのリセット対象フィールド
export const COMMON_ROW_RESET_FIELDS = [
  ...DATA_ROW_RESET_FIELDS,
  ...COMMON_RESET_FIELDS
];

// 報告対象外チェックON時のリセットフィールド
export const NOT_REPORT_RESET_FIELDS = [
  'occured_at',
  'is_selected_drainage_powerplant',
  'is_notified_irrigation_user1',
  'intake_stop_notifier_person',
  'intake_stop_at',
  'intake_stop_contact_person',
  'intake_stop_completed_at',
  'drainage_notice_sent_at',
  'drainage_notice_sent_person',
  'drainage_notice_sent_user',
  'drainage_completed_at',
  'is_selected_inspection_locations',
  'canalinspector1',
  'canalinspector2',
  'is_canalinspector',
  'request_emergency_inspection_at',
  'request_emergency_inspection_person',
  'request_emergency_inspection_user',
  'inspection_completed_at',
  'is_emergency_inspection',
  'is_manager_report',
  'is_drainage',
  'drainage_request_at',
  'drainage_request_person',
  'drainage_request_user',
  'drainage_at',
  'is_inspection_completed_update_form1',
  'perform_internal_inspection_user1',
  'perform_internal_inspection_user2',
  'is_perform_internal_inspection_user',
  'internal_inspection_completed_at',
  'is_internal_inspection_update_form1',
  'is_decide_restart_locations',
  'is_notified_irrigation_user2',
  'request_waterway_refill_at',
  'request_waterway_refill_person',
  'request_waterway_refill_user',
  'refill_completed_at',
  'is_report_to_g_manager',
  'restart_power_generation_at',
  'is_notified_irrigation_user3',
  'is_completed'
];

// 取水停止チェックON時のリセットフィールド
export const INTAKE_STOP_RESET_FIELDS = [
  'drainage_notice_sent_at',
  'drainage_notice_sent_person',
  'drainage_notice_sent_user',
  'drainage_completed_at',
  'is_selected_inspection_locations',
  'canalinspector1',
  'canalinspector2',
  'is_canalinspector'
];

// 水路抜水チェックON時のリセットフィールド
export const DRAINAGE_RESET_FIELDS = [
  'is_drainage',
  'drainage_request_at',
  'drainage_request_person',
  'drainage_request_user',
  'drainage_at'
];

// 運転継続チェックON時のリセットフィールド
export const CONTINUE_RESET_FIELDS = [
  'is_notified_irrigation_user1',
  'intake_stop_at',
  'intake_stop_notifier_person',
  'intake_stop_contact_person',
  'intake_stop_completed_at',
  'drainage_notice_sent_at',
  'drainage_notice_sent_person',
  'drainage_notice_sent_user',
  'drainage_completed_at',
  'is_selected_inspection_locations',
  'canalinspector1',
  'canalinspector2',
  'is_canalinspector'
];

// 臨時点検異常ありチェックOFF時のリセットフィールド
export const EMERGENCY_INSPECTION_RESET_FIELDS = [
  'is_manager_report',
  'is_drainage',
  'drainage_request_at',
  'drainage_request_person',
  'drainage_request_user',
  'drainage_at',
  'is_inspection_completed_update_form1',
  'perform_internal_inspection_user1',
  'perform_internal_inspection_user2',
  'is_perform_internal_inspection_user',
  'internal_inspection_completed_at',
  'is_internal_inspection_update_form1',
  'is_decide_restart_locations',
  'is_notified_irrigation_user2',
  'request_waterway_refill_at',
  'request_waterway_refill_person',
  'request_waterway_refill_user',
  'refill_completed_at',
  'is_report_to_g_manager',
  'restart_power_generation_at',
  'is_notified_irrigation_user3'
];
